import { useSearchParams } from 'react-router-dom'
import { getPreviewTask, getPreviewTaskForExpert } from 'Services/tasks.service'
import { PAGE_TITLES } from 'Constants/page.constants'
import { NavigationSource } from 'Constants/constants.ts'
import { TaskFeedbackPreview } from './TaskFeedbackPreview'

export const TaskPreview = () => {
    const [searchParams] = useSearchParams()
    const source = searchParams.get('source')

    return (
        <TaskFeedbackPreview
            pageTitle={PAGE_TITLES.TASK_PREVIEW}
            getDetails={(taskId, userId) =>
                source === NavigationSource.INTERNAL
                    ? getPreviewTask(taskId)
                    : getPreviewTaskForExpert(taskId, userId)
            }
        />
    )
}
